export default __webpack_public_path__ + "static/media/mihile.5b747889.png";